"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_table_filtering_1 = require("./awsui-table-filtering");
var awsui_table_property_filtering_1 = require("./awsui-table-property-filtering");
var awsui_table_preferences_1 = require("./awsui-table-preferences");
var awsui_table_pagination_1 = require("./awsui-table-pagination");
var TableWrapper = /** @class */ (function (_super) {
    __extends(TableWrapper, _super);
    function TableWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableWrapper.prototype.findNativeTable = function () {
        return this.find('.awsui-table-container table');
    };
    TableWrapper.prototype.findActiveTHead = function () {
        return this.find('thead.awsui-table-sticky-active');
    };
    TableWrapper.prototype.findHeaderRegion = function () {
        return this.find('.awsui-table-header');
    };
    TableWrapper.prototype.findColumnHeaders = function () {
        return this.findActiveTHead().findAll('tr > *');
    };
    /**
     * Returns the element the user clicks when resizing a column.
     *
     * @param columnIndex 1-based index of the column containing the resizer.
     */
    TableWrapper.prototype.findColumnResizer = function (columnIndex) {
        return this.findActiveTHead().find("th:nth-child(" + columnIndex + ") .awsui-table-resizable-columns-resizer");
    };
    /**
     * Returns a table cell based on given row and column indices.
     *
     * @param rowIndex 1-based index of the row of the cell to select.
     * @param columnIndex 1-based index of the column of the cell to select.
     */
    TableWrapper.prototype.findBodyCell = function (rowIndex, columnIndex) {
        return this.findNativeTable().find("tbody tr:nth-child(" + rowIndex + ") td:nth-child(" + columnIndex + ") ");
    };
    TableWrapper.prototype.findRows = function () {
        return this.findNativeTable().findAll('tbody tr.awsui-table-row');
    };
    TableWrapper.prototype.findSelectedRows = function () {
        return this.findAll('.awsui-table-row-selected');
    };
    TableWrapper.prototype.findNoMatchRegion = function () {
        return this.find('[awsui-table-region="noMatch"]');
    };
    TableWrapper.prototype.findEmptyRegion = function () {
        return this.find('[awsui-table-region="empty"]');
    };
    TableWrapper.prototype.findLoadingSpinner = function () {
        return this.find('.awsui-table-row-merged awsui-spinner');
    };
    TableWrapper.prototype.findLoadingText = function () {
        return this.find('.awsui-table-row-merged .awsui-util-status-inactive');
    };
    /**
     * Returns the column that is used for ascending sorting.
     */
    TableWrapper.prototype.findAscSortedColumn = function () {
        return this.findNativeTable().find('.awsui-table-column-sorted-asc');
    };
    /**
     * Returns the column that is used for descending sorting.
     */
    TableWrapper.prototype.findDescSortedColumn = function () {
        return this.findNativeTable().find('.awsui-table-column-sorted-desc');
    };
    /**
     * Returns a row selection area for a given index.
     *
     * @param rowIndex 1-based index of the row selection area to return.
     */
    TableWrapper.prototype.findRowSelectionArea = function (rowIndex) {
        return this.findNativeTable().find("tbody tr:nth-child(" + rowIndex + ") .awsui-table-selection-area");
    };
    TableWrapper.prototype.findSelectAllTrigger = function () {
        return this.findActiveTHead().find('.awsui-table-selection-trigger');
    };
    TableWrapper.prototype.findFiltering = function () {
        return new awsui_table_filtering_1.default(this.find('awsui-table-filtering').getElement());
    };
    TableWrapper.prototype.findPropertyFiltering = function () {
        return new awsui_table_property_filtering_1.default(this.find('awsui-table-property-filtering').getElement());
    };
    TableWrapper.prototype.findPreferences = function () {
        return new awsui_table_preferences_1.default(this.find('awsui-table-preferences').getElement());
    };
    TableWrapper.prototype.findPagination = function () {
        return new awsui_table_pagination_1.default(this.find('awsui-table-pagination').getElement());
    };
    return TableWrapper;
}(dom_1.ComponentWrapper));
exports.default = TableWrapper;
//# sourceMappingURL=awsui-table.js.map